/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Sync_Space_SuccessInputs */



/**
* | output |
* | --- |
* | "Space synced successfully!" |
*
* @param {Spaces_Sync_Space_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_sync_space_success = /** @type {((inputs?: Spaces_Sync_Space_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Sync_Space_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherplatz erfolgreich synchronisiert!")
	return /** @type {LocalizedString} */ ("Space synced successfully!")
});